import { useTranslation } from "react-i18next";
import { Skeleton } from "@/components/ui/skeleton";

export function StatNumber({ value, label, unavailable = false }: { value: number | undefined; label: string; unavailable?: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-0.5">
      {unavailable ? <span role="status" className="text-sm text-muted-foreground">{t("common.dataUnavailable")}</span> : value === undefined
        ? <Skeleton className="h-8 w-12" />
        : <span className="text-3xl font-bold tabular-nums text-foreground leading-none">{value}</span>
      }
      <span className="text-xs text-muted-foreground">{label}</span>
    </div>
  );
}
